// Stage Mail-3:MailPage(本物)。
//
// design §5.3:
// - MailPage.tsx:mock.ts 直接 import を廃止
// - Sidebar badge は /api/mail/unread-count を叩いて実数表示(Sidebar.tsx 側)
// - Dashboard mail feed は /api/mail/messages?limit=4 を叩く(Dashboard.tsx 側)
// - Mail 設定 (/settings) は Mail-1 で実装済、ページ遷移でアクセス可能

import React, { useCallback, useState } from "react";
import { Card } from "../../components/ui/Card";
import { MailList } from "./MailList";
import { MailDetail } from "./MailDetail";

export const MailPage = () => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(0);

  const refreshList = useCallback(() => {
    setRefresh((n) => n + 1);
  }, []);

  return (
    <div className="mail-grid">
      <MailList
        selectedId={selectedId}
        onSelect={(id) => setSelectedId(id)}
        refreshSignal={refresh}
      />
      <MailDetail
        messageId={selectedId}
        onChanged={refreshList}
      />
      {/* 右パネル(顧客メモ/問い合わせ履歴/タグ)は Mail-3 範囲外。
         mock.ts の customerHistory は Mail-3 では使用しない。
         1.0 範囲で CRM 化するかどうかは 1.1 以降。 */}
      <Card>
        <div
          style={{
            padding: 16,
            color: "#9ca3af",
            fontSize: 13,
            textAlign: "center",
          }}
        >
          顧客メモ / 問い合わせ履歴 / タグ機能は Mail-3 範囲外(1.1 以降予定)。
        </div>
      </Card>
    </div>
  );
};
